export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img src="/assets/logo/logo-full-dark-text.png" alt="badges.ninja" className="h-9" />
        </div>

        {/* Card */}
        <div className="rounded-2xl bg-white border border-gray-200 shadow-sm px-8 py-8 sm:px-10">
          {children}
        </div>
      </div>
    </div>
  );
}
